import { z } from 'zod';
/**
 * BYOK — usuário fornece a key do provider de IA. Nunca persiste em DB.
 */
export const ProviderIdSchema = z.enum(['anthropic', 'openai', 'google', 'openrouter']);
export const ProviderConfigSchema = z.object({
    provider: ProviderIdSchema,
    apiKey: z.string().min(10, 'API key precisa ter ao menos 10 caracteres'),
    modelId: z.string().optional(),
});
/**
 * Versão pública sanitizada — NUNCA contém apiKey.
 */
export const ProviderConfigPublicSchema = z.object({
    provider: ProviderIdSchema,
    modelId: z.string(),
    validatedAt: z.string(),
});
/**
 * Defaults de modelo por provider.
 */
export const PROVIDER_DEFAULT_MODEL = {
    anthropic: 'claude-sonnet-4-5-20250929',
    openai: 'gpt-4.1',
    google: 'gemini-2.5-flash',
    openrouter: 'anthropic/claude-sonnet-4',
};
/**
 * Modelos sugeridos exibidos na UI por provider (curados).
 */
export const PROVIDER_SUGGESTED_MODELS = {
    anthropic: [
        { id: 'claude-haiku-4-5', label: 'Haiku 4.5 (rápido, barato)', tier: 'fast' },
        { id: 'claude-sonnet-4-5-20250929', label: 'Sonnet 4.5 (recomendado)', tier: 'balanced' },
        { id: 'claude-opus-4-1', label: 'Opus 4.1 (qualidade máxima)', tier: 'premium' },
    ],
    openai: [
        { id: 'gpt-4.1-mini', label: 'GPT-4.1 mini (rápido, barato)', tier: 'fast' },
        { id: 'gpt-4.1', label: 'GPT-4.1 (recomendado)', tier: 'balanced' },
        { id: 'gpt-4o', label: 'GPT-4o', tier: 'balanced' },
    ],
    // Catálogo validado contra a API real em 2026-07-28 (generateContent com
    // chave free tier NOVA): 2.5-flash-lite responde 404 "no longer available
    // to new users" (embora ainda apareça em models.list) e 2.5-pro responde
    // 429 de cota no free tier. Só entram modelos que retornaram 200.
    google: [
        { id: 'gemini-3.5-flash-lite', label: 'Gemini 3.5 Flash-Lite (rápido, barato)', tier: 'fast' },
        { id: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash (recomendado)', tier: 'balanced' },
        { id: 'gemini-3.6-flash', label: 'Gemini 3.6 Flash (mais recente)', tier: 'premium' },
    ],
    openrouter: [
        { id: 'anthropic/claude-haiku-4-5', label: 'Claude Haiku 4.5', tier: 'fast' },
        { id: 'anthropic/claude-sonnet-4', label: 'Claude Sonnet 4 (recomendado)', tier: 'balanced' },
        { id: 'openai/gpt-4o', label: 'GPT-4o', tier: 'balanced' },
        { id: 'google/gemini-2.5-flash', label: 'Gemini 2.5 Flash', tier: 'balanced' },
    ],
};
//# sourceMappingURL=provider-config.js.map